import { forwardRef, type InputHTMLAttributes } from 'react';
import clsx from 'clsx';
import styles from './TextInput.module.css';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

export const TextInput = forwardRef<HTMLInputElement, Props>(
  ({ invalid, className, ...rest }, ref) => (
    <input
      ref={ref}
      className={clsx(styles.input, invalid && styles.invalid, className)}
      {...rest}
    />
  ),
);
TextInput.displayName = 'TextInput';